import React, {useEffect} from 'react';
import {ContactosMensajes} from './ContactosMensajes';
import {CabezeraMensajes} from './CabezeraMensajes';
import {ChatMensajes} from './ChatMensajes';
import {useMenuContacts} from '../../hooks/useMenuContacts';
import {animateScroll as scroll} from 'react-scroll';

/* Exporting the `ContentMiMensajes` component. */
export const ContentMiMensajes = () => {
	/* Destructuring the useMenuContacts hook. */
	const {EstadoMenu, ClassContentMimensajes, closeMenuContacts} = useMenuContacts();

	/* Returning the following: */
	return (
		<div className={ClassContentMimensajes}>
			<CabezeraMensajes closeMenuContacts={closeMenuContacts} />
			{
				/* A conditional rendering. If `EstadoMenu` is true, then it will render `<ContactosMensajes
        />`. */
				EstadoMenu && <ContactosMensajes />
			}
			<ChatMensajes />
		</div>
	);
};
